// File: src/utils/whatsappUtils.js

export const sendToWhatsApp = (productName, price, category, quantity = 1) => {
  const phoneNumber = "919234041819"; // Aapka WhatsApp Number
  
  // Price formatting (agar string me '₹' hai to usko handle karega)
  const formattedPrice = price.toString().startsWith('₹') ? price : `₹${price}`;
  
  // Total price logic fix: Agar price string hai (e.g., '₹1200'), to quantity multiply nahi hoga direct,
  // isliye hum check kar rahe hain
  let totalPrice;
  if (typeof price === 'number') {
    totalPrice = `₹${price * quantity}`;
  } else {
    // Agar price string hai (Home page se), to hum seedha wahi price dikhayenge
    totalPrice = quantity > 1 ? `${formattedPrice} (x${quantity})` : formattedPrice;
  }

  const message = `Namaste UnnatKheti, main aapki website se order karna chahta hu:

📦 *Product Name:* ${productName}
🏷️ *Category:* ${category}
💰 *Price:* ${formattedPrice}
🔢 *Quantity:* ${quantity}
💵 *Total Value:* ${totalPrice}

Please confirm availability and payment details.`;

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
};